import "../../../css/Buttons/NewCheckButton.css";
import { ReactComponent as NewCheckIcon } from "../../../assets/icons/new-check.svg";

const NewCheckButton = ({ label, onClick, color }) => {
  return (
    <div className={`New-Check-Button ${color}`} onClick={onClick}>
      <NewCheckIcon />
      <div className="AML-Text-Input">{label}</div>
    </div>
  );
};

export default NewCheckButton;
